import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=46124f1e&scoped=true"
import script from "./InvoicesTable.vue?vue&type=script&lang=js"
export * from "./InvoicesTable.vue?vue&type=script&lang=js"
import style0 from "./InvoicesTable.vue?vue&type=style&index=0&id=46124f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46124f1e",
  null
  
)

export default component.exports